import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

export const deleteAnalyzerPermission = ({
  userId,
  analyzerId,
}: {
  userId: number;
  analyzerId: number;
}) => {
  return axios.delete(
    `/api/users/${userId}/analyzer/${analyzerId}/permissions`
  );
};

type UseDeleteAnalyzerPermissionOptions = {
  userId: number;
  config?: MutationConfig<typeof deleteAnalyzerPermission>;
};

export const useDeleteAnalyzerPermission = ({
  userId,
  config,
}: UseDeleteAnalyzerPermissionOptions) => {
  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(['user', userId]);
    },
    ...config,
    mutationFn: deleteAnalyzerPermission,
  });
};
